module.exports = __webpack_public_path__ + "static/media/BizLogo.e49cb496.png";